<template>
    <Disclosure as="nav" class="bg-gradient-to-b from-pitch-purple to-dark-pitch-purple shadow text-white" v-slot="{ open }">
        <div class="mx-auto px-2 sm:px-6 lg:px-8">
            <div class="relative flex justify-between h-16">
                <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
                    <!-- Mobile menu button -->
                    <DisclosureButton
                        class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                        <span class="sr-only">Open main menu</span>
                        <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true"/>
                        <XIcon v-else class="block h-6 w-6" aria-hidden="true"/>
                    </DisclosureButton>
                </div>
                <div class="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                    <div class="flex-shrink-0 flex items-center lg:gap-3">
                        <img class="block h-8 w-auto"
                             src="/images/logo/pitch-logo.svg"
                             alt="Pitch Logo"/>
                        <span class="font-bold text-white text-xl font-pitch">Pitch</span>
                    </div>
                    <div class="hidden sm:ml-6 sm:flex sm:space-x-8">
                        <!-- Current: "border-light-pitch-purple text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
                        <Link :href="route('frontend.fixture.index')"
                              :class="$page.component.startsWith('Frontend') && !$page.component.includes('Unit4') ? 'border-gray-300 text-gray-100' : 'border-transparent text-gray-300 hover:border-gray-300 hover:text-gray-200' "
                              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm">
                            Dashboard
                        </Link>
                        <Link v-if="can_access_admin === true" :href="route('admin.index')"
                              :class="$page.component.startsWith('Admin')  ? 'border-gray-300 text-gray-100' : 'border-transparent text-gray-300 hover:border-gray-300 hover:text-gray-200' "
                              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm">
                            Admin
                        </Link>
                        <Link :href="route('unit-4-settings.index')"
                              :class="$page.component.includes('Unit4')  ? 'border-gray-300 text-gray-100' : 'border-transparent text-gray-300 hover:border-gray-300 hover:text-gray-200' "
                              class="inline-flex items-center px-1 pt-1 border-b-2 text-sm">
                            Unit 4 Settings
                        </Link>
                    </div>
                </div>
                <div class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                    <!--                        <button type="button" class="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">-->
                    <!--                            <span class="sr-only">View notifications</span>-->
                    <!--                            <BellIcon class="h-6 w-6" aria-hidden="true" />-->
                    <!--                        </button>-->

                    <!-- Profile dropdown -->
                    <Menu as="div" class="ml-3 relative">
                        <div>
                            <MenuButton
                                class="bg-white rounded-full flex text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                <span class="sr-only">Open user menu</span>
                                <img class="h-8 w-8 rounded-full" :src="user.avatar_url" alt=""/>
                            </MenuButton>
                        </div>
                        <transition enter-active-class="transition ease-out duration-200"
                                    enter-from-class="transform opacity-0 scale-95"
                                    enter-to-class="transform opacity-100 scale-100"
                                    leave-active-class="transition ease-in duration-75"
                                    leave-from-class="transform opacity-100 scale-100"
                                    leave-to-class="transform opacity-0 scale-95">
                            <MenuItems
                                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                                <MenuItem v-slot="{ active }">
                  <span @click="emitter.emit('openExpenseSlideout')"
                        :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700 cursor-pointer']">Add Expense</span>
                                </MenuItem>
                                <MenuItem v-slot="{ active }">
                                    <Link :href="route('logout')" method="post"
                                          :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                                        Sign out
                                    </Link>
                                </MenuItem>
                            </MenuItems>
                        </transition>
                    </Menu>
                </div>
            </div>
        </div>

        <div v-if="unit_4_queue_open && unit4Warning" class="mx-auto px-2 sm:px-6 lg:px-8 bg-red-500 text-center">
            <p class="text-white p-2 uppercase font-bold">
                Unit 4 Sync Is Turned Off
            </p>
        </div>

        <DisclosurePanel class="sm:hidden">
            <div class="pt-2 pb-4 space-y-1 ">
                <!-- Current: "bg-indigo-50 border-light-pitch-purple text-dark-pitch-purple", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" -->
                <DisclosureButton as="a" href="#"
                                  class="bg-indigo-50 border-light-pitch-purple text-dark-pitch-purple block pl-3 pr-4 py-2 border-l-4 text-base">
                    Dashboard
                </DisclosureButton>
                <DisclosureButton as="a" href="#"
                                  class="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base">
                    Admin
                </DisclosureButton>
            </div>
        </DisclosurePanel>
    </Disclosure>

    <div class="mx-auto px-2 sm:px-6 lg:px-8 shadow">
        <nav class="hidden lg:pt-2 lg:flex lg:space-x-8" aria-label="Global">
            <template v-for="item in activeNavigation" :key="item.name">
                <Link :href="item.href"
                    :class="[$page.component.startsWith(item.component) ? 'bg-gray-100 text-gray-900 border-light-pitch-purple text-gray-900 border-b-2' : 'text-gray-900 hover:border-light-pitch-purple hover:border-b-2 hover:pb-[5.5px]', 'py-2 px-3 inline-flex items-center text-sm']"
                    :aria-current="item.current ? 'page' : undefined"
                    v-if="showNavItem(item)"
                >
                    {{ item.name }}
                    <span v-if="item.nav_count !== undefined && item.nav_count > 0"
                        class="bg-red-700 text-white rounded-full pl-2 pr-2 ml-2">{{ item.nav_count }}</span>
                </Link>
            </template>
        </nav>
    </div>
    <CreateExpense/>

</template>

<script>
import {computed} from "vue";
import {emitter} from "@/eventHub";
import {Link, usePage} from '@inertiajs/vue3';
import CreateExpense from "@/Components/SlideOuts/CreateExpense";
import {BellIcon, MenuIcon, XIcon, ExclamationCircleIcon} from '@heroicons/vue/outline';
import {Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems} from '@headlessui/vue';

export default {
    components: {
        Disclosure,
        DisclosureButton,
        DisclosurePanel,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        BellIcon,
        MenuIcon,
        XIcon,
        Link,
        CreateExpense
    },
    data() {
        return {
            emitter: emitter,
            navigation: [
                {
                    name: 'Organisations',
                    href: route('frontend.organisations.index'),
                    component: 'Frontend/Organisations',
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'Fixtures',
                    href: route('frontend.fixture.index'),
                    component: 'Frontend/Fixtures',
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'Expenses',
                    href: route('frontend.expenses.index'),
                    component: 'Frontend/Expenses',
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'Management Fees',
                    href: route('frontend.management-fees.index'),
                    component: 'Frontend/ManagementFees',
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'Reports',
                    href: route('frontend.reports.index'),
                    component: 'Frontend/Reports',
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'Finance Import', 
                    href: route('frontend.finance-import.index'), 
                    component: 'Frontend/FinanceImport', 
                    section: 'Frontend',
                    restriction: 'none'
                },
                {
                    name: 'BT Supplier Import', 
                    href: route('frontend.bt-supplier-import.index'), 
                    component: 'Frontend/BTSupplierImport', 
                    section: 'Frontend',
                    restriction: 'finance'
                },
                {
                    name: 'Supplier Invoices', 
                    href: route('frontend.supplier-invoices.index'), 
                    component: 'Frontend/SupplierInvoices', 
                    section: 'Frontend',
                    restriction: 'none',
                    nav_count: usePage().props.suppliers_to_review
                },
                {
                    name: 'Credit Card Expense Import', 
                    href: route('frontend.credit-card-expense-import.index'), 
                    component: 'Frontend/CreditCardExpenseImport', 
                    section: 'Frontend',
                    restriction: 'finance'
                },
                {
                    name: 'Expenses For Review', 
                    href: route('frontend.expenses-for-review.index'), 
                    component: 'Frontend/ExpensesReview', 
                    section: 'Frontend',
                    restriction: 'none',
                    nav_count: usePage().props.expenses_to_review
                },
                {
                    name: 'Overview', 
                    href: route('admin.index'), 
                    component: 'Admin/Index', 
                    section: 'Admin',
                    restriction: 'none'
                },
                {
                    name: 'Users', 
                    href: route('admin.users.index'), 
                    component: 'Admin/Users', 
                    section: 'Admin',
                    restriction: 'none'
                },
                {
                    name: 'Change Logs',
                    href: route('admin.change-logs.index'),
                    component: 'Admin/ChangeLogs',
                    section: 'Admin',
                    restriction: 'none'
                },
                {
                    name: 'Settings', 
                    href: route('admin.settings.index'), 
                    component: 'Admin/Settings', 
                    section: 'Admin',
                    restriction: 'none'
                },
            ],
            unit_4_queue_open: usePage().props.unit_4_queue_open,
            unit4Warning: false
        }
    },
    mounted() {
        this.checkUnit4Warning();
    },
    computed: {
        activeNavigation: function () {
            let page = this.$page;
            return this.navigation.filter(function (n) {
                return page.component.startsWith(n.section)
            })
        }        
    },
    setup() {
        const user = computed(() => usePage().props.auth.user)
        const can_access_admin = computed(() => usePage().props.auth.can_access_admin)
        return {
            user,
            can_access_admin
        }
    },
    methods: {
        openExpenseSlideout() {

        },
        showNavItem(nav_item) {
            let user_role = usePage().props.auth.user_role;
            if (nav_item.restriction == 'none') {
                return true;
            } else if (nav_item.restriction == 'finance' && (user_role == 1 || user_role == 4)) {
                return true;
            }
            return false;
        },
        checkUnit4Warning() {
            let user_role = usePage().props.auth.user_role;
            if (user_role == 1 || user_role == 4) {
                this.unit4Warning = true;
            } else {
                this.unit4Warning = false;
            }
        }
    }
}
</script>
